import React from "react";
import { size } from "lodash";
import { IllustrationProps } from ".";

export default ({
  colors: {
    base,
    chart: { primary },
    scheme,
  },
  options: { showPrevious },
}: IllustrationProps) => {
  const currentLineColor = size(scheme) === 1 ? scheme[0] : primary;

  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 440 120"
      fill="none"
      strokeWidth={3}
    >
      <path stroke={currentLineColor} d="M0 106l146-23 147-63 147 53" />
      {showPrevious && <path stroke={base} d="M0 64l146 54 147-46 147 46" />}
    </svg>
  );
};
